import {IHttpService} from "angular";
import {OrderVettingResponse} from "../types/OrderVettingResponse";
import {PlaceOrderRequest} from "./models/PlaceOrderRequest";
import {SingleAccountEquityOrderRequest} from "./models/PlaceMultiAccountOrderRequest";

export class OrderVettingService {

    public static id = "orderVettingService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async validate(portfolioId: number,
                          trades: ReadonlyArray<PlaceOrderRequest>): Promise<OrderVettingResponse> {
        const url = `/tradefloor/api/order-vetting/${portfolioId}`;
        const response = await this.$http.post<OrderVettingResponse>(url, trades);
        return response.data!;
    }

    public async validateMultiAccount(trades?: ReadonlyArray<SingleAccountEquityOrderRequest>): Promise<OrderVettingResponse[]> {
        const url = `/tradefloor/api/order-vetting`;
        const response = await this.$http.post<OrderVettingResponse[]>(url, trades);
        return response.data!;
    }

}
